import React from 'react';
import { useIntl } from 'react-intl';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Collapse from '@nubank/nuds-web/components/Collapse/Collapse';
import Link from '@nubank/nuds-web/components/Link/Link';
import { htmlToText } from 'html-to-text';
import { Grid } from '@nubank/nuds-web/components/Grid/Grid';

import questions from './faq.json';

const FAQ = () => {
  const { formatMessage } = useIntl();

  return (
    <Box
      tag="section"
      height="100%"
      width="100%"
      marginBottom={{ xs: '16x', lg: '120px' }}
      paddingHorizontal={{ xs: '32px', lg: '56px' }}
      backgroundColor="#F8F8FA"
      paddingVertical={{ xs: '12x', lg: '32x' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        {/* CONTENT BOX */}

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >
          <Box maxWidth="1390px" margin="0 auto">

            <Typography
              intlKey="CREDIT_CARD.FAQ.TITLE"
              variant="heading2"
            />

            {questions.map(({
              id, question, answer, answerSecondLine,
            }, index) => (
              <Box
                marginTop={{ xs: '16x', md: 60, lg: 56 }}
                key={id}
              >
                <Collapse
                  id={id}
                  initiallyOpen={index === 0}
                >
                  <Collapse.Header>
                    <Typography color="black.light" variant="subtitle1" strong>
                      {question}
                    </Typography>
                  </Collapse.Header>
                  <Collapse.Body>
                    <Typography variant="subtitle1">
                      {htmlToText(answer)}
                    </Typography>
                    <Typography variant="subtitle1" marginTop="4x">
                      {htmlToText(answerSecondLine)}
                    </Typography>
                  </Collapse.Body>
                </Collapse>
              </Box>
            ))}

            <Link
              marginTop={{ xs: '8x', md: 60 }}
              href={formatMessage({ id: 'CREDIT_CARD.FAQ.PATH' })}
              variant="action"
              intlKey="CREDIT_CARD.FAQ.LINK"
              width="fit-content"
            />
          </Box>
        </Grid.Child>
      </Grid>
    </Box>
  );
};

export default FAQ;
